import * as actionTypes from 'actions';

const initialState = {
  installationCounts: [],
  installationCountsLoading: false,
  devices: [],
  devicesLoading: false,
  selectedVersion: null
};

const softwareDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FIND_FIELD_PRODUCTION_CELL_SOFTWARE_VERSION_INSTALLATION_COUNTS_PENDING: {
      return {
        ...state,
        installationCounts: initialState.installationCounts,
        installationCountsLoading: true
      };
    }

    case actionTypes.FIND_FIELD_PRODUCTION_CELL_SOFTWARE_VERSION_INSTALLATION_COUNTS_FULFILLED: {
      return {
        ...state,
        installationCounts: action.payload.data.result,
        selectedVersion: action.payload.data.result.length
          ? action.payload.data.result[0].version
          : null,
        installationCountsLoading: false
      };
    }

    case actionTypes.FIND_SOFTWARE_DASHBOARD_VERSION_DEVICES_PENDING: {
      return {
        ...state,
        devices: initialState.devices,
        devicesLoading: true
      };
    }

    case actionTypes.FIND_SOFTWARE_DASHBOARD_VERSION_DEVICES_FULFILLED: {
      return {
        ...state,
        devices: action.payload.data.result.items,
        devicesLoading: false
      };
    }

    case actionTypes.SET_SOFTWARE_DASHBOARD_SELECTED_VERSION: {
      return {
        ...state,
        selectedVersion: action.payload
      };
    }

    default: {
      return state;
    }
  }
};

export default softwareDashboardReducer;
